import React from "react";
import { Input, Select } from "antd";
import { FilterField, ToggleRow, CheckboxGrid } from "./FilterShared";
import { INDUSTRY_OPTIONS, COMPANY_SIZE_OPTIONS } from "./filterOptions";

const BASE_SELECT = { style: { width: "100%" }, allowClear: true };
const TAG_SELECT  = { ...BASE_SELECT, mode: "tags", filterOption: false, tokenSeparators: [","] };

const CompanyPanel = ({
  values = {},
  set,
  setE,
  hideAdvancedFields = false,
  companySearch,
}) => {
  const safeSet = (key) => set?.(key) || (() => {});
  const safeSetE = (key) => setE?.(key) || (() => {});
  const useCompanySuggestions = hideAdvancedFields && companySearch;

  return (
    <div className="qp-filter-panel-body">
      <FilterField label="Company (Include)">
        <Select
          {...TAG_SELECT}
          showSearch
          placeholder="e.g. Google"
          value={Array.isArray(values.companyInclude) ? values.companyInclude : []}
          onChange={safeSet("companyInclude")}
          onSearch={useCompanySuggestions ? companySearch.onSearch : undefined}
          loading={Boolean(useCompanySuggestions && companySearch.loading)}
          options={
            useCompanySuggestions && Array.isArray(companySearch.opts)
              ? companySearch.opts
              : []
          }
          notFoundContent={
            useCompanySuggestions && companySearch.loading
              ? "Searching..."
              : "Type to search or add"
          }
        />
      </FilterField>

    {!hideAdvancedFields && (
      <FilterField label="Company (Exclude)">
        <Select
          {...TAG_SELECT}
          showSearch
          placeholder="e.g. Meta"
          value={values.companyExclude}
          onChange={safeSet("companyExclude")}
          notFoundContent="Type to add"
        />
      </FilterField>
    )}

    {!hideAdvancedFields && (
      <FilterField>
        <ToggleRow
          leftLabel="Current company only"
          leftChecked={values.companyCurrentOnly}
          onLeft={safeSet("companyCurrentOnly")}
          rightLabel="Include past companies"
          rightChecked={values.companyIncludeRelated}
          onRight={safeSet("companyIncludeRelated")}
        />
      </FilterField>
    )}

    {!hideAdvancedFields && (
      <FilterField label="Domain">
        <Input
          placeholder="e.g. www.google.com"
          value={values.domain}
          onChange={safeSetE("domain")}
        />
      </FilterField>
    )}

    {!hideAdvancedFields && (
      <FilterField label="Industry">
        <Select
          {...BASE_SELECT}
          mode="multiple"
          showSearch
          placeholder="Select industries"
          filterOption={(input, option) =>
            option.label.toLowerCase().includes(input.toLowerCase())
          }
          value={values.industry}
          onChange={safeSet("industry")}
          options={INDUSTRY_OPTIONS.map((o) => ({ label: o.title, value: o.value }))}
        />
      </FilterField>
    )}

    {!hideAdvancedFields && (
      <FilterField label="Company Size">
        <CheckboxGrid
          options={COMPANY_SIZE_OPTIONS}
          value={values.companySize}
          onChange={safeSet("companySize")}
        />
      </FilterField>
    )}
    </div>
  );
};

export default CompanyPanel;
